import React from 'react';

import AzulLogoSVG from '~/assets/svgs/insurance-companies/azul-logo.svg';
import HdiLogoSVG from '~/assets/svgs/insurance-companies/hdi-logo.svg';
import SuhaiLogoSVG from '~/assets/svgs/insurance-companies/suhai-logo.svg';
import PortoLogoSVG from '~/assets/svgs/insurance-companies/porto-logo.svg';

interface Props {
  name: string | null;
  height?: number;
  width?: number;
}

const InsuranceCompanyLogo: React.FC<Props> = ({ name, height, width }) => {
  if (!name) return null;

  const params = {
    width: width || 45,
    height: height || 35,
  };

  switch (name) {
    case 'azul':
      return <AzulLogoSVG {...params} />;
    case 'hdi':
      return <HdiLogoSVG {...params} />;
    case 'suhai':
      return <SuhaiLogoSVG {...params} />;
    case 'porto':
      return <PortoLogoSVG {...params} />;
    default:
      return null;
  }
};

export default InsuranceCompanyLogo;
